import { getUserInfo, getAdminUrl } from '@/api/auth'
const user = {
  state: {
    token: '',
    exp: '',
    userInfo: {
      nick_name: '',
      avatar: ''
    }
  },

  mutations: {
    setToken (state, payload) {
      // console.log('[commit]-setToken', payload.token)
      state.token = payload.token
    },
    setTokenExp (state, payload) {
      state.exp = payload.exp
    },
    setUserInfo (state, payload) {
      state.userInfo = Object.assign(state.userInfo, payload)
    },
    clearUser (state, payload) {
      state.token = ''
      state.userInfo = {
        nick_name: '',
        avatar: ''
      }
    }
  },

  actions: {
    async getUserInfo ({ commit, state }) {
      const userInfo = await getUserInfo()
      commit('setUserInfo', userInfo)
    },
    async getAdminUrl ({ commit, state }) {
      const Url = await getAdminUrl() // 动态获取 销售中心的URL
      const userInfo = state.userInfo
      userInfo.adminUrl =
        Url.url && Url.url.includes(':') ? Url.url.split(':')[1] : process.env.VUE_APP_SHOP_IFRAME
      console.log(user, 'user来自token')
      commit('setUserInfo', userInfo)
    },
    setTokenExp ({ commit }, exp) {
      commit('setTokenExp', exp)
    },
    // 保存token
    async setToken ({ commit, state }, token) {
      console.log('[dispatch]-setToken', token)
      commit('setToken', token)
    }
    // // 删除token
    // unsetToken({ commit }, token) {
    //   commit('setToken', '')
    //   commit('setTokenExp', '')
    //   commit('setUserName', '')
    //   commit('setAuthorizer', '')
    //   commit('setLicenseAuthorize', '')
    // },
    // setUser({ commit }, userInfo) {
    //   commit('setNickName', userInfo.username)
    //   commit('setAvatar', userInfo.head_portrait)
    // },
    // setWxappId({ commit }, wxapp_id) {
    //   commit('setWxappId', wxapp_id)
    // },
    // setTemplateName({ commit }, template_name) {
    //   commit('setTemplateName', template_name)
    // },
    // setLoginType({ commit }, login_type) {
    //   commit('setLoginType', login_type)
    // }
  }
}

export default user
